module.exports = __webpack_public_path__ + "static/oisix-aafb589dc3f1ebba7f5f1182bfd20473.svg";